/* @ngInject */
const email = (
  emailAsk,
  emailRequest,
  emailMetadata
) => {
  const self = {}

  self.new = () => {
    return {
      id: null,
      email: null,
      contactId: null,
    }
  }

  self.ask = emailAsk
  self.request = emailRequest
  self.metadata = emailMetadata

  return self
}

export default email



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/services/email.service.js